export default [
  'ApplicationConfigData',
  class PrivacyPolicyController {
    constructor (applicationConfigData) {
      this.config = applicationConfigData.getConfig();
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/pages/legal/privacy-policy/privacy-policy.ctrl.js